import { connect } from 'react-redux';
import {
  searchPartRequest,
  addPartRequest,
  successfullyAddedSupersededPart,
} from './parts-actions';
import Parts from '../components/parts';

const mapStateToProps = state => ({
  addedParts: state.order.parts.addedParts,
  addSuccess: state.order.parts.addSuccess,
  decimalMask: state.serviceCenter.isDecimal,
  serviceCenterId: state.navigation.navigationSelf.serviceCenterId,
});

const mapDispatchToProps = { searchPartRequest, addPartRequest, successfullyAddedSupersededPart };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Parts);
